import React, { useState, useRef } from "react";
import { Header, Modal } from "../../../../../components";
import { Button, Input } from "antd";
import { UseFetchCreateInput } from "../hooks/useFetch";
import Table from "../components/table";
import * as XLSX from "xlsx";
import dayjs from "dayjs";

function InputPage() {
  const titlePage = "Masterdata Input";
  const [dataInputs, setDataInputs] = useState([]);
  const { mutate: createInput, isLoading: isCreating } = UseFetchCreateInput();

  const handleFileUpload = (event) => {
    const fileInput = event.target;
    const file = fileInput.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = "ชีต1"; // Explicitly target 'Sheet1'
      const worksheet = workbook.Sheets[sheetName];

      if (!worksheet) {
        console.error(`Sheet '${sheetName}' not found in the Excel file.`);
        fileInput.value = ""; // Clear the file input
        return;
      }

      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      fileInput.value = "";
      const dataFormatted = formatData(jsonData);
      setDataInputs(dataFormatted);
    };
    reader.readAsArrayBuffer(file);
  };
  const formatData = (jsonData) => {
    let data = [];
    for (let i = 1; i < jsonData.length; i++) {
      if (jsonData[i][0] === null || jsonData[i][0] === undefined) break;
      data.push({
        No: i,
        userName: jsonData[i][0],
        amount: jsonData[i][2],
        caseType: jsonData[i][1],
        date: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        remark: jsonData[i][4],
      });
    }
    return data;
  };
  const handleCreateInput = async () => {
    // console.log(dataInputs);
    await createInput(dataInputs);
    setDataInputs([]);
  };
  return (
    <div className="md:m-10">
      <div className="flex justify-between">
        <Header category="App" title={titlePage} />
        <div style={{ display: "flex", gap: "8px", marginLeft: "auto" }}>
          <Button
            type="primary"
            style={{ backgroundColor: "#1677ff", color: "#fff" }}
            onClick={() => document.getElementById("input-file-upload").click()}
          >
            เพิ่มไฟล์
          </Button>
          <Button
            type="primary"
            style={{ backgroundColor: dataInputs.length === 0 ? "#ccc" : "#47d604", color: "#fff" }}
            onClick={() => handleCreateInput()}
            disabled={dataInputs.length === 0 ? true : false}
          >
            ส่งข้อมูล
          </Button>
          <Button
            type="primary"
            style={{ backgroundColor: dataInputs.length === 0 ? "#ccc" : "#ff4d4f", color: "#fff" }}
            onClick={() => setDataInputs([])}
            disabled={dataInputs.length === 0 ? true : false}
          >
            ล้างข้อมูล
          </Button>
        </div>
        <input
          id="input-file-upload"
          type="file"
          accept=".xlsx,.xls"
          onChange={handleFileUpload}
          style={{ display: "none" }}
        />
      </div>
      <Table data={dataInputs} bordered />
    </div>
  );
}

export default InputPage;
